export default "/images/ic_apanhar_peixe.svg?efc428b2a42325c7ede75fbb7fb9bd24";